import { CardComponentProps } from "@~/types/types";
import styles from "./GiftMessagesIndicator.module.scss";
import { IconButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/IconButton";
import { FeedbackOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/FeedbackOutlined";
import { VIEW_GIFT_MESSAGES } from "@~/utils/events";

export function GiftMessagesIndicator({
  product,
}: Pick<CardComponentProps, "product">) {
  const { giftMessageCount = 0 } = product;

  if (giftMessageCount === 0) {
    return null;
  }

  const handleClick = () => {
    window.dispatchEvent(
      new CustomEvent(VIEW_GIFT_MESSAGES, {
        detail: { pimProductId: product.aliases.pimProductId },
      }),
    );
  };

  return (
    <div
      data-component="GiftMessagesIndicator"
      className={styles.giftMessagesButton}
    >
      <IconButton
        onClick={handleClick}
        data-testid="view-messages-button"
        ariaLabel="View messages"
        size="small"
        IconComponent={FeedbackOutlined}
      ></IconButton>
      <div className={styles.countIndicator}>
        <div className={styles.countText}>{giftMessageCount}</div>
      </div>
    </div>
  );
}
